import { publishUrl } from './PublishStore';
import { publishUrlDefault } from './PublishStoreDefaults';

export const resetPublishUrl = () => publishUrl.set(publishUrlDefault);
